import Kr from 'Kr/kr';
import 'KrComponent/MenuMobile';
import 'KrComponent/HeaderFixed';
import 'KrComponent/LayoutGallery';
import 'KrComponent/NavTo';
import 'KrComponent/Collapse';
import 'KrComponent/OpinionSlider';
import 'KrComponent/BMICalc';
import 'KrComponent/Popup';

import LinkClass from 'KrModule/LinkClass';
import BuyRotator from 'KrModule/BuyRotator';

const app = new Kr.App;

app.use('link-class', LinkClass);
app.use('buy-rotator', BuyRotator);
app.run();
